module.exports = __webpack_public_path__ + "static/img/envelope03en.5017caa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/envelope03en.png
// module id = bFWf
// module chunks = 1